import { Component, OnInit, OnDestroy, Input,AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import {FileService} from "../../../_services/file.service";
import { CareerInfoService } from '../../../_services/index';

@Component({
  selector: 'app-academic-career-goals',
  templateUrl: './academic-career-goals.component.html',
  styleUrls: ['./academic-career-goals.component.css'],
  providers:[CareerInfoService]

})
export class AcademicCareerGoalsComponent implements OnInit, OnDestroy {

  careerGoalForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  academicMajorSub: Subscription;
  personalGoalSub: Subscription;


  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  public personalEmail: string;
  currentUser:any;
  loading: boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  academicMajorData:any;
  professionalGoalsData:any;
  public checkingSubmit = false;

  constructor( private _fb: FormBuilder,
    private router: Router,
    public api: CareerInfoService ) { }

  ngOnInit() {

    this.createForm();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail=this.currentUser?this.currentUser.email:'';
    this.careerGoalForm.get('personalEmail').setValue(this.personalEmail);
    this.academicMajorList();
    this.professionalGoalsList();
    this.getCareerInfo();
    window.scrollTo(300, 500)

  }

  ngOnDestroy() {

    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if (this.academicMajorSub)  {
      this.academicMajorSub.unsubscribe();
    }
    if (this.personalGoalSub)  {
      this.personalGoalSub.unsubscribe();
    }


  }

  private _onValueChanged() {

    if(this.checkChange)
    {
      //console.log('aca-cr');
      this.valueChange = true

    }

  }

  createForm()  {
    this.careerGoalForm  = this._fb.group({
      personalEmail: ['', [Validators.required]],
      academicMajor: ['',[Validators.required]],
      professionalGoal: ['',[Validators.required]]

    });

    this.formChangeSub = this.careerGoalForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

  }

  academicMajorList() {

    this.academicMajorSub = this.api.academicMajorList()
        .subscribe(responseData => {
          //this.checkChange = false;
            if ( responseData.status === 1) {
                this.academicMajorData = responseData.data.academicmajor;
                this.careerGoalForm.patchValue({
                  academicMajor: this.academicMajorData[0].id
                });
            }
        });
  }

  professionalGoalsList() {

    this.personalGoalSub = this.api.professionalGoalsList()
        .subscribe(responseData => {
          //this.checkChange = false;
            if ( responseData.status === 1) {
                this.professionalGoalsData = responseData.data.professionalgoals;
                this.careerGoalForm.patchValue({
                  professionalGoal: this.professionalGoalsData[0].id
                });
            }

        });
  }


 onSubmit()  {

    const body = JSON.stringify({
      academicMajor: this.careerGoalForm.controls.academicMajor.value,
      professionalGoal: this.careerGoalForm.controls.professionalGoal.value,
      personalEmail:this.careerGoalForm.controls.personalEmail.value,
    });

    //console.log(body);

    this.submitting = true;
    this.api.postCareerInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
            this.errorFlag = false;
            this.successMessage = response.message;
            if(!this.canDeactivateCheck)
            {
              this.checkingSubmit = true;

              this.router.navigate(['/profile/extracurricular']);
            }
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
          }
        },
      );
    //console.log(this);
  }

  getCareerInfo() {

    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getCareerInfo(body)

      .subscribe(responsedata => {
          //console.log(responsedata.data);
          let carrerInfodata = responsedata.data;

          setTimeout(()=>{

            if(carrerInfodata.academicmajor_id)
            {
              this.careerGoalForm.controls['academicMajor'].setValue(carrerInfodata.academicmajor_id);

            }

            if(carrerInfodata.professionalgoals_id)
            {
              this.careerGoalForm.controls['professionalGoal'].setValue(carrerInfodata.professionalgoals_id);

            }

            this.loading = false;
            this.checkChange = true;

          },1000);

        });
  }

  canDeactivate() {

    //console.log('i am navigating away from academic');

    //console.log(this.valueChange);

    if(this.valueChange  && this.checkingSubmit == false)
    {
      if(confirm("Want to save changes?")) {

        this.canDeactivateCheck = true;

        this.onSubmit();

      }
    }

    return true;
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/academic-career-goals/academic-career-goals.component.ts